import { PrefetchMediaUrl } from './prefetch-media-url';

export class MarketingAssetUrl extends PrefetchMediaUrl {}
